export enum AlertChannel {
  UI = 'UI',
  SLACK = 'SLACK',
  EMAIL = 'EMAIL',
  JIRA = 'JIRA'
}
